import React from "react";
import { Stepper, Step, StepLabel, StepConnector } from "@mui/material";
import { styled } from "@mui/material/styles";
import { StepIconProps } from "@mui/material/StepIcon";
import classNames from "classnames";

interface StepItem {
  title: string;
  icon?: React.ReactNode;
}

interface StepperComponentProps {
  steps: StepItem[];
  currentStep: number;
  onStepClick: (step: number) => void;
}

interface IconProps {
  active?: boolean;
  completed?: boolean;
}

const CustomStepIcon = styled("div")<IconProps>(({ active, completed }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 45,
  height: 45,
  borderRadius: 8,
  zIndex: 2,
  cursor: "pointer",
  transition: "0.25s ease",
  backgroundColor: active || completed ? "#2D7DEF" : "#ababab",
  color: active || completed ? "#fff" : "#F9F9F9",
}));

const CustomStepConnector = styled(StepConnector)(() => ({
  marginTop: 14,
  left: "calc(-50% + 34px)",
  right: "calc(50% + 34px)",

  "& .MuiStepConnector-line": {
    borderTop: "2px dashed #ababab",
  },

  "&.Mui-active .MuiStepConnector-line": {
    borderTop: "2px dashed #FF6C23",
  },

  "&.Mui-completed .MuiStepConnector-line": {
    borderTop: "2px dashed #FF6C23",
  },
}));

const StepperComponent: React.FC<StepperComponentProps> = ({
  steps,
  currentStep,
  onStepClick,
}) => {
  return (
    <Stepper
      activeStep={currentStep}
      alternativeLabel
      connector={<CustomStepConnector />}
    >
      {steps.map((step, index) => (
        <Step
          key={step.title}
          onClick={() => onStepClick(index)}
          sx={{ cursor: "pointer" }}
        >
          <StepLabel
            StepIconComponent={(props: StepIconProps) => (
              <CustomStepIcon
                active={currentStep >= index}
                completed={currentStep >= index}
              >
                {step.icon}
              </CustomStepIcon>
            )}
          >
            <div
              className={classNames("text-center text-xs", {
                "text-bgSidebar": currentStep >= index,
                "text-[#748194]": currentStep < index,
              })}
            >
              {step.title}
            </div>
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};

export default StepperComponent;
